import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ColumnGroup } from 'react-table';

import i18next from 'i18next';

export const useColumns = () => {
  const { t } = useTranslation();

  return useMemo(
    (): ColumnGroup[] => [
      {
        Header: 'Budgets',
        columns: [
          {
            Header: t('catalogue.fabric')!,
            accessor: 'fabric',
          },
          {
            Header: t('catalogue.material')!,
            accessor: 'mainFabricDesc',
          },
          {
            Header: t('budget.prevSold')!,
            accessor: 'prevSold',
          },
          {
            Header: t('product.sold')!,
            accessor: 'currSold',
          },
          {
            Header: t('statistics.forecast')!,
            accessor: 'forecast',
            Cell: ({ row }) => (
              <span>{row.original.currSold + row.original.currQuantity}</span>
            ),
          },
        ],
      },
    ],
    [i18next.language]
  );
};
